import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JobStatistics } from '../interfaces/job-statistics.interface';

@Injectable({
  providedIn: 'root'
})
export class JobStatisticsService {
  readonly url: string = 'jobStatistics';

	constructor(private http: HttpClient) {}

	public getJobStatistics(linkId: number): Observable<JobStatistics[]> {
		return this.http.get<JobStatistics[]>(`${this.url}/getJobStatistics/${linkId}`);
	}

}
